import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useJsonLd } from "@/lib/useJsonLd";

const DOMAIN = "https://meridianbedbug.ca";

/**
 * Visible breadcrumb navigation that also emits a BreadcrumbList
 * JSON-LD block for the current route.
 * items: [{ name: string, to?: string }]  — last item is the current page.
 */
export default function Breadcrumbs({ items, className = "" }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => {
      const entry = { "@type": "ListItem", position: i + 1, name: it.name };
      if (it.to) entry.item = DOMAIN + it.to;
      return entry;
    }),
  };
  useJsonLd("breadcrumb-jsonld", jsonLd);

  const last = items.length - 1;

  return (
    <nav aria-label="Breadcrumb" className={`text-sm text-muted-foreground ${className}`}>
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-1.5">
            {i < last && it.to ? (
              <Link to={it.to} className="hover:text-accent">{it.name}</Link>
            ) : (
              <span aria-current={i === last ? "page" : undefined} className="text-foreground">{it.name}</span>
            )}
            {i < last && <ChevronRight className="h-3.5 w-3.5 text-muted-foreground/60" />}
          </li>
        ))}
      </ol>
    </nav>
  );
}